import Vue from 'vue'
import baseAxios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store'
import router from '@/router'

const myAxios = baseAxios.create({
  // baseURL: 'http://localhost:4000/api/',
  baseURL: '/api/',
  timeout: 15000
})

myAxios.interceptors.request.use(
  config => {
    const token = store.state.user.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    store.dispatch('incrementLoading')
    return config
  },
  error => {
    store.dispatch('decrementLoading')
    return Promise.reject(error)
  }
)
myAxios.interceptors.response.use(
  response => {
    store.dispatch('decrementLoading')
    return response
  },
  error => {
    store.dispatch('decrementLoading')
    if (error.response.status === 401 && !error.response.data.includes('Unauthorized Login')) {
      store.dispatch('user/logout').then(
        () => {
          router.replace('/login')
        }
      )
    }
    return Promise.reject(error)
  }
)

Vue.use(VueAxios, myAxios)

export default myAxios



// WEBPACK FOOTER //
// ./src/api/axios.js